import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('TaskFormController', TaskFormController);

    function TaskFormController(
        $scope,
        $state,
        $http,
        $stateParams,
        $translate,
        CompanyFactory,
        CompaniesFactory,
        PeriodicTasksFactory,
        FormVerificationService,
        toastr,
    ) {
        var vm = this;

        init();

        function init() {
            vm.getAssets = function (_, params) {
                return $http.get(`/api/v1/assets/search/`, { params });
            };

            vm.getAssetChildren = function (assetId) {
                return $http.get(`/api/v1/assets/${assetId}/`);
            };

            vm.startDate = null;
            vm.endDate = null;
            vm.reminderTime = null;
            vm.editMode = false;

            vm.clientSelected = clientSelected;
            vm.imClientSelected = imClientSelected;
            vm.iwClientSelected = iwClientSelected;
            vm.onClientChange = onClientChange;
            vm.addAsset = addAsset;
            vm.removeAsset = removeAsset;
            vm.clientHasAssets = clientHasAssets;
            vm.save = save;

            // store client selected from dropdown list or set by using asset search input
            vm.client = null;

            // store list of customers of the given organization
            vm.customers = [];

            // store list of assets owned by the selected client
            vm.asets = [];

            // store assets selected from dropdown list
            vm.selectedAssets = [[null, null, null]];

            // store asset found by using search input
            vm.foundAsset = null;

            CompanyFactory.readCompany()
                .then(function (response) {
                    vm.company = response.data.organization.party_uuid;

                    CompaniesFactory.readCompanies(vm.company).then(
                        function (companyResponse) {
                            vm.companySettings = companyResponse.data;

                            watchClientFieldChanges();
                            watchFoundAssetChange();
                        },
                    );

                    CompaniesFactory.readHousingAssociations(vm.company, {
                        page_size: 10000,
                    }).then(function (housingResponse) {
                        vm.customers = housingResponse.data.results;
                    });
                })
                .then(function () {
                    if ($stateParams.id) {
                        vm.editMode = true;
                        return PeriodicTasksFactory.readOne(
                            $stateParams.id,
                        ).then((res) => {
                            return CompaniesFactory.readOneHa(res.data.customer)
                                .then(function (response) {
                                    vm.client = response.data;
                                })
                                .then(() => {
                                    return initComponentData(res.data);
                                });
                        });
                    }
                });
        }

        function initComponentData(taskData) {
            vm.initialRepeaterConfig = taskData.repeater_config;
            vm.description = taskData.description;
            vm.additionalPersonalData = taskData.additional_personal_data;
            if (taskData.category && taskData.category_id) {
                vm.category = {
                    id: taskData.category_id,
                    name: taskData.category,
                };
            }
            vm.issueCategory = taskData.issue_category;
            vm.startDate = taskData.start_date;
            vm.endDate = taskData.end_date;
            vm.reminderTime = taskData.reminder_time;
            vm.locations = taskData.locations;
            if (vm.editMode) {
                vm.selectedAssets = [];
                vm.locations.forEach(function (loc) {
                    if (loc.asset) {
                        vm.getAssetChildren(loc.asset.asset_id).then(
                            (response) => {
                                loc.asset.children = response.data.children;
                                if (loc.sub_asset) {
                                    loc.asset.children.forEach(
                                        function (subloc) {
                                            if (
                                                subloc.asset_id ===
                                                loc.sub_asset.asset_id
                                            ) {
                                                loc.sub_asset.children =
                                                    subloc.children;
                                            }
                                        },
                                    );
                                }
                                vm.selectedAssets.push([
                                    loc.asset,
                                    loc.sub_asset,
                                    loc.sub_sub_asset,
                                ]);
                            },
                        );
                    } else {
                        vm.selectedAssets.push([loc.address, null, null]);
                    }
                });
            }
        }

        function prepareComponentDataToSave() {
            let data: any = {
                repeater_config: vm.repeaterConfig,
                locations: fillLocation(),
                description: vm.description,
                additional_personal_data: vm.additionalPersonalData || '',
                customer: vm.client.party_uuid,
            };
            if (imClientSelected()) {
                data.category = vm.category?.name;
                data.category_id = vm.category?.id;
                data.issue_category = null;
            } else {
                data.category = '';
                data.category_id = null;
                data.issue_category = vm.issueCategory;
            }
            if (vm.startDate) {
                data.start_date = vm.startDate;
            }
            if (vm.endDate) {
                data.end_date = vm.endDate;
            }
            if (vm.reminderTime) {
                data.reminder_time = vm.reminderTime;
            }

            return data;
        }

        function clientSelected(): boolean {
            return vm.client;
        }

        function imClientSelected(): boolean {
            return vm.client?.som;
        }

        function iwClientSelected(): boolean {
            return vm.client && !vm.client.som;
        }

        function addAsset() {
            vm.selectedAssets.push([null, null, null]);
        }

        function removeAsset(index) {
            vm.selectedAssets.splice(index, 1);
        }

        function clientHasAssets(): boolean {
            return vm.assets?.length;
        }

        function save() {
            let data = prepareComponentDataToSave();

            if (vm.editMode) {
                PeriodicTasksFactory.update($stateParams.id, data).then(
                    function () {
                        toastr.success(
                            $translate.instant('common.changes_saved'),
                        );
                        $state.go(
                            'company_employee.periodic_tasks.task_list.task_details',
                            { id: $stateParams.id },
                            { reload: true },
                        );
                    },
                    function (response) {
                        FormVerificationService.error(response.data, vm.form);
                    },
                );
            } else {
                PeriodicTasksFactory.create(data).then(
                    function () {
                        toastr.success(
                            $translate.instant('common.changes_saved'),
                        );
                        $state.go('company_employee.periodic_tasks.task_list');
                    },
                    function (response) {
                        FormVerificationService.error(response.data, vm.form);
                    },
                );
            }
        }

        function fillLocation() {
            return vm.selectedAssets.map(function (asset) {
                if (typeof asset[0] === 'string') {
                    return { short_address: asset[0] };
                }
                return {
                    asset: asset[0] && asset[0].asset_id,
                    sub_asset: (asset[1] && asset[1].asset_id) || null,
                    sub_sub_asset: (asset[2] && asset[2].asset_id) || null,
                    sub_premise:
                        (asset[1] && asset[1].sub_premise) ||
                        (asset[2] && asset[2].sub_premise) ||
                        null,
                };
            });
        }

        function onClientChange() {
            vm.selectedAssets = [[null, null, null]];
        }

        function watchClientFieldChanges() {
            $scope.$watch(
                function () {
                    return vm.client;
                },
                function (newVal) {
                    if (vm.company && clientSelected()) {
                        CompaniesFactory.getLocations({
                            page_size: 1000,
                            customer: vm.client.party_uuid,
                        }).then(function (response) {
                            vm.assets = response.data.results;
                            if (newVal) {
                                if (
                                    vm.client?.party_uuid !== newVal.party_uuid
                                ) {
                                    onClientChange();
                                }
                            }
                        });
                    }
                },
            );
        }

        function watchFoundAssetChange() {
            $scope.$watch(
                function () {
                    return vm.foundAsset;
                },
                function (newVal) {
                    if (newVal) {
                        if (vm.client?.party_uuid !== newVal.customer) {
                            onClientChange();
                        }
                        vm.client = vm.customers.find(
                            (c) => c.party_uuid === newVal.customer,
                        );
                        vm.selectedAssets = [[newVal, null, null]];
                        vm.foundAsset = null;
                    }
                },
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/periodic_tasks/task_form/task_form.controller.ts